import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './components/dialog/dialog.component';
import { DialogDirective } from './components/dialog/dialog.directive';
import { MaterialModule } from 'src/shared-app-portal/material.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { InjectorModule } from '../app/shared/modules/injector.module';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { PhoneNumberDisplayPipe } from './pipes/phone-number-display.pipe';
import { EditPhoneComponent } from './components/phone/phone.component';
import { PhoneInputComponent } from './components/phone-input/phone-input.component';
import { AddressEditorComponent } from 'src/shared-app-portal/components/address-editor/address-editor.component';
import { RequiredAriaDirective } from './directives/required-aria.directive';
import { ReadOnlyAddressComponent } from './components/read-only-address/read-only-address.component';
import { CountryNamePipe } from './pipes/country-name.pipe';
import { AddressWarningDialogComponent } from 'src/portal/dialogs/address-warning.dialog/address-warning.dialog.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { ProfileCustomFieldEditorComponent } from './components/profile-custom-field-editor/profile-custom-field-editor.component';
import { CustomFieldEditorModalComponent } from './components/custom-field-editor-modal/custom-field-editor-modal.component';
import { AttributesEditorComponent } from './components/attributes-editor/attributes-editor.component';
import { StarRatingAttributeComponent } from './components/star-rating-attribute/star-rating-attribute.component';
import { CustomDocumentViewerComponent } from './components/custom-document-viewer/custom-document-viewer.component';
import { ComplexFieldViewerComponent } from './components/complex-field-viewer/complex-field-viewer.component';
import { SkillComponent } from './components/skill/skill.component';
import { DateRangeComponent } from './components/daterange/daterange.component';
import { Base64UrlEncodedPipe } from './pipes/base64-url-encoded';
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MultiselectComponent } from './components/multiselect/multiselect.component';
import { CustomDocumentUploaderComponent } from './components/custom-document-uploader/custom-document-uploader.component';
import { FileUploadModule } from 'ng2-file-upload';
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { ModalConfirmationComponent } from './components/modal-confirmation/modal-confirmation.component';
import { ComplexFieldEditorComponent } from './components/complex-field-editor/complex-field-editor.component';
import { InvoiceStatusIconPipe } from './pipes/invoice-status-icon.pipe';
import { PaymentConfirmationComponent } from './components/profile-payments/payment-confirmation/payment-confirmation.component';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { PaymentsTableComponent } from './components/profile-payments/payment-table/payments-table.component';
import { InvitationComponent } from './components/lineup-applications/invitation/invitation.component';
import { ApplicationClosedComponent } from './components/lineup-applications/application-closed/application-closed.component';
import { InvalidApplicationComponent } from './components/lineup-applications/invalid-application/invalid-application.component';
import { EvaluationRespondItemComponent } from './components/lineup-applications/evaluation/evaluation-respond/evaluation-respond-item/evaluation-respond-item.component';
import { EvaluationRespondComponent } from './components/lineup-applications/evaluation/evaluation-respond/evaluation-respond.component';
import { EvaluationIntroductionComponent } from './components/lineup-applications/evaluation/evaluation-introduction/evaluation-introduction.component';
import { EvaluationExpiredComponent } from './components/lineup-applications/evaluation/evaluation-expired/evaluation-expired.component';
import { EvaluationConfirmationComponent } from './components/lineup-applications/evaluation/evaluation-confirmation/evaluation-confirmation.component';
import { EvaluationComponent } from './components/lineup-applications/evaluation/evaluation.component';
import { EmailPreferencesComponent } from './components/lineup-applications/email-preferences/email-preferences.component';
import { SurveyExpiredComponent } from './components/lineup-applications/survey/survey-expired/survey-expired.component';
import { ApplicationConfirmationComponent } from './components/lineup-applications/application/application-confirmation/application-confirmation.component';
import { SurveyComponent } from './components/lineup-applications/survey/survey.component';
import { SurveyIntroductionComponent } from './components/lineup-applications/survey/survey-introduction/survey-introduction.component';
import { SurveyRespondComponent } from './components/lineup-applications/survey/survey-respond/survey-respond.component';
import { SurveyConfirmationComponent } from './components/lineup-applications/survey/survey-confirmation/survey-confirmation.component';
import { ApplicationComponent } from './components/lineup-applications/application/application.component';
import { ValidationSummaryComponent } from './components/lineup-applications/validation-summary/validation-summary.component';
import { ApplicationPaymentComponent } from './components/lineup-applications/application-payment/application-payment.component';
import { RouterModule } from '@angular/router';
import { DocumentUploadComponent } from './components/document-upload/document-upload.component';
import { AddressComponent } from './components/address/address.component';
import { CloudinaryUploadComponent } from './components/cloudinary-upload/cloudinary-upload.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { ThrottleClickDirective } from './directives/throttle/throttle-click.directive';
import { StepperAriaFixDirective } from './directives/stepper-aria-fix.directive';
import { ForbidAngleBracketsDirective } from '../app/shared/directives/forbid-angle-brackets.directive';
import { ItemPickerComponent } from 'src/app/shared/components/item-picker/item-picker.component';
import { FilterPipe } from 'src/app/shared/components/item-picker/filter.pipe';
import { EmailEditorComponent } from './components/email-editor/email-editor.component';
import { PositionPersonPickerComponent } from './components/lineup-applications/application/position-person-picker/position-person-picker.component';
import { PositionSearchResultComponent } from './components/lineup-applications/application/position-person-picker/position-search-result/position-search-result.component';
import { FieldLabelComponent } from './components/field-label/field-label.component';
import { PlatformLabelPipe } from 'src/app/shared/pipes/platform-label.pipe';
import { CredentialSnapshotComponent } from './components/credential-snapshot/credential-snapshot.component';
import { CredentialApplicationCardComponent } from './components/credential-application-card/credential-application-card.component';
import { WarningBannerComponent } from './components/warning-banner/warning-banner.component';

@NgModule({
  declarations: [
    DialogComponent,
    DialogDirective,
    PhoneNumberDisplayPipe,
    EditPhoneComponent,
    PhoneInputComponent,
    AddressEditorComponent,
    RequiredAriaDirective,
    ThrottleClickDirective,
    StepperAriaFixDirective,
    ForbidAngleBracketsDirective,
    ReadOnlyAddressComponent,
    CountryNamePipe,
    AddressWarningDialogComponent,
    SafeUrlPipe,
    SafeHtmlPipe,
    ProfileCustomFieldEditorComponent,
    CustomFieldEditorModalComponent,
    AttributesEditorComponent,
    StarRatingAttributeComponent,
    CustomDocumentViewerComponent,
    ComplexFieldViewerComponent,
    SkillComponent,
    DateRangeComponent,
    Base64UrlEncodedPipe,
    RichTextEditorComponent,
    MultiselectComponent,
    CustomDocumentUploaderComponent,
    LocalDatePipe,
    StarRatingComponent,
    ModalConfirmationComponent,
    ComplexFieldEditorComponent,
    LocalDatePipe,
    InvoiceStatusIconPipe,
    PaymentConfirmationComponent,
    PaymentsTableComponent,
    InvitationComponent,
    ApplicationClosedComponent,
    InvalidApplicationComponent,
    SurveyExpiredComponent,
    EmailPreferencesComponent,
    EvaluationComponent,
    EvaluationConfirmationComponent,
    EvaluationExpiredComponent,
    EvaluationIntroductionComponent,
    EvaluationRespondComponent,
    EvaluationRespondItemComponent,
    ApplicationConfirmationComponent,
    SurveyComponent,
    SurveyIntroductionComponent,
    SurveyRespondComponent,
    SurveyConfirmationComponent,
    ApplicationComponent,
    ValidationSummaryComponent,
    ApplicationPaymentComponent,
    DocumentUploadComponent,
    AddressComponent,
    CloudinaryUploadComponent,
    AvatarComponent,
    ItemPickerComponent,
    FilterPipe,
    EmailEditorComponent,
    PositionPersonPickerComponent,
    PositionSearchResultComponent,
    FieldLabelComponent,
    PlatformLabelPipe,
    CredentialSnapshotComponent,
    CredentialApplicationCardComponent,
    WarningBannerComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    NgScrollbarModule,
    ReactiveFormsModule,
    FormsModule,
    InjectorModule,
    FlexLayoutModule,
    CKEditorModule,
    FileUploadModule,
    RouterModule
  ],
  exports: [
    PositionPersonPickerComponent,
    DialogComponent,
    DialogDirective,
    ThrottleClickDirective,
    StepperAriaFixDirective,
    MaterialModule,
    NgScrollbarModule,
    ReactiveFormsModule,
    CKEditorModule,
    FileUploadModule,
    FormsModule,
    RouterModule,
    InjectorModule,
    FlexLayoutModule,
    PhoneNumberDisplayPipe,
    EditPhoneComponent,
    PhoneInputComponent,
    AddressEditorComponent,
    RequiredAriaDirective,
    ForbidAngleBracketsDirective,
    ReadOnlyAddressComponent,
    CountryNamePipe,
    AddressWarningDialogComponent,
    SafeUrlPipe,
    SafeHtmlPipe,
    ProfileCustomFieldEditorComponent,
    CustomFieldEditorModalComponent,
    AttributesEditorComponent,
    StarRatingAttributeComponent,
    CustomDocumentViewerComponent,
    ComplexFieldViewerComponent,
    SkillComponent,
    DateRangeComponent,
    Base64UrlEncodedPipe,
    RichTextEditorComponent,
    MultiselectComponent,
    CustomDocumentUploaderComponent,
    LocalDatePipe,
    StarRatingComponent,
    ModalConfirmationComponent,
    ComplexFieldEditorComponent,
    LocalDatePipe,
    InvoiceStatusIconPipe,
    PaymentConfirmationComponent,
    PaymentsTableComponent,
    InvitationComponent,
    ApplicationClosedComponent,
    InvalidApplicationComponent,
    SurveyExpiredComponent,
    EmailPreferencesComponent,
    EvaluationComponent,
    EvaluationConfirmationComponent,
    EvaluationExpiredComponent,
    EvaluationIntroductionComponent,
    EvaluationRespondComponent,
    EvaluationRespondItemComponent,
    ApplicationConfirmationComponent,
    SurveyComponent,
    SurveyIntroductionComponent,
    SurveyRespondComponent,
    SurveyConfirmationComponent,
    ApplicationComponent,
    ValidationSummaryComponent,
    ApplicationPaymentComponent,
    DocumentUploadComponent,
    AddressComponent,
    CloudinaryUploadComponent,
    AvatarComponent,
    ItemPickerComponent,
    FilterPipe,
    EmailEditorComponent,
    PlatformLabelPipe,
    CredentialSnapshotComponent,
    CredentialApplicationCardComponent,
    WarningBannerComponent
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class SharedAppPortalModule {}
